import { Emoji } from '@/utils/functions';

import { FC } from 'react';
import { Button } from '../../buttons';
import styles from './TermsAndPrivacy.module.css';

interface TermsAndPrivacyUpdatedProps {
  onClose: () => void;
  name?: string;
}

export const TermsAndPrivacyUpdated: FC<TermsAndPrivacyUpdatedProps> = ({ onClose, name }) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Hi {name},</h3>
      <div className={styles.updatedDescription}>
        We&apos;ve updated our Terms and Conditions. These changes take effect from 11/10/2024.
      </div>

      <h4 className={styles.listTitle}>Key updates include:</h4>
      <ul className={styles.list}>
        <li className={styles.listItem}>increased clarity around our compliance obligations and our services;</li>
        <li className={styles.listItem}>changes to our referral program;</li>
        <li className={styles.listItem}>expanding our list of prohibited conduct.</li>
      </ul>

      <div className={styles.updatedDescription}>
        Please review the full Terms at{' '}
        <span className={styles.linkText}>
          <a
            href="https://relaypay.io/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            https://www.relaypay.io/terms-and-conditions.
          </a>
        </span>
      </div>

      <div className={styles.updatedDescription}>
        By continuing to use our services after 11/10/2024, you agree to these updated Terms.
      </div>
      <div className={styles.updatedDescription}>
        If you have any questions, please contact us at{' '}
        <a className={styles.linkText} href="mailto:support@relaypay.io.">
          support@relaypay.io.
        </a>
      </div>
      <div className={styles.updatedDescription}>
        Thank you for your continued support. <div>RelayPay Team</div>
      </div>

      <Button fluid onPress={onClose} className={styles.button}>
        I understand
      </Button>
    </div>
  );
};
